import { inject, provideAppInitializer } from '@angular/core';

import { UiStore } from '@pt/services';

import { registerAnalyticsFactory, registerLocaleFactory } from './factories';

/**
 * Core app initializers
 */
export const CORE_APP_INITIALIZERS = [
  provideAppInitializer(() => {
    return inject(UiStore).init();
  }),
  provideAppInitializer(() => {
    const initializerFn = (registerLocaleFactory)();
    return initializerFn();
  }),
  provideAppInitializer(() => {
    const initializerFn = (registerAnalyticsFactory)();
    return initializerFn();
  }),
];
